import React from 'react';
import { Calendar, Users, Upload, MessageCircle, Edit, Eye, CheckCircle, Download } from 'lucide-react';
import './ProcessTimeline.css';

const ProcessTimeline = () => {
  const steps = [
    {
      icon: Calendar,
      title: 'Book Your Slot',
      description: 'Choose your preferred service and timeline through our simple booking system',
      color: '#A83D5B'
    },
    {
      icon: Users,
      title: 'Team Connects',
      description: 'Our team connects with you to understand style, vision, and expectations',
      color: '#6B2E4C'
    },
    {
      icon: Upload,
      title: 'Data Transfer',
      description: 'Secure file sharing via OneDrive, Google Drive, Dropbox, or courier (India)',
      color: '#A83D5B'
    },
    {
      icon: MessageCircle,
      title: 'Work Begins',
      description: 'Editing starts on the booked date with clear communication throughout the process',
      color: '#6B2E4C'
    },
    {
      icon: Edit,
      title: 'Professional Editing',
      description: 'Our expert editors craft your footage using industry-standard tools and workflows',
      color: '#A83D5B'
    },
    {
      icon: Eye,
      title: 'Preview Round',
      description: 'A near-final preview is shared for your review and feedback',
      color: '#6B2E4C'
    },
    {
      icon: CheckCircle,
      title: 'Final Corrections',
      description: 'Your revisions are carefully applied to perfect every detail',
      color: '#A83D5B'
    },
    {
      icon: Download,
      title: 'Delivery',
      description: 'Final files delivered in your preferred format after approval',
      color: '#6B2E4C'
    }
  ];

  return (
    <section className="process-timeline section">
      <div className="container">
        <div className="process-header">
          <h2 className="section-title">
            How We <span className="gradient-text">Work</span>
          </h2>
          <p className="section-subtitle">
            Our transparent 8-step process for exceptional results
          </p>
        </div>

        <div className="process-grid">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="process-card">
                <div className="process-number">{index + 1}</div>
                <div className="process-icon-wrapper" style={{ background: step.color }}>
                  <Icon size={32} className="process-icon" />
                </div>
                <h3 className="process-card-title">{step.title}</h3>
                <p className="process-card-description">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;